// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PREGNANCY_NEWSLETTER_BANNER_TEXT = "Odoberaj tehotensk\u00fd newsletter! ";
export const PREGNANCY_NEWSLETTER_HINT = "Si tehotn\u00e1?";
